<template>
  <ol
    v-if="items.length > 1"
    class="breadcrumb"
  >
    <li
      v-for="(item, index) in items"
      :key="item.name"
    >
      <router-link
        v-if="index !== items.length - 1"
        class="text-muted"
        :to="{ name: item.name }"
        v-text="item.title"
      />
      <span
        v-else
        v-text="item.title"
      />
    </li>
  </ol>
</template>

<script>
import breadcrumbs from '../../breadcrumbs'

/**
 * Хлебные крошки.
 */
export default {
  name: 'TheBreadcrumbs',
  data () {
    return {
      items: []
    }
  },
  watch: {
    $route: {
      handler () {
        this.load()
      }
    }
  },
  mounted () {
    this.load()
    this.$root.$on('breadcrumbTitleUpdated', this.handleBreadcrumbTitleUpdated)
  },
  destroyed () {
    this.$root.$off('breadcrumbTitleUpdated', this.handleBreadcrumbTitleUpdated)
  },
  methods: {
    /**
     * Обновляет заголовок определенной ХК.
     *
     * @param {string} name
     * @param {string} title
     */
    handleBreadcrumbTitleUpdated ({ name, title }) {
      const item = this.items.find(item => item.name === name)

      if (item) {
        item.title = title
      }
    },
    /**
     * Загружает цепочку ХК для текущего роута.
     */
    load () {
      this.items = this.find(breadcrumbs, this.$route.name) || []
    },
    /**
     * Возвращает цепочку ХК для указанного роута.
     *
     * @param breadcrumb
     * @param {string} name
     * @returns {{name, title}[]|*[]}
     */
    find (breadcrumb, name) {
      if (breadcrumb.name === name) {
        return []
      }

      if (Array.isArray(breadcrumb.children)) {
        for (const children of breadcrumb.children) {
          const childResult = this.find(children, name)

          if (Array.isArray(childResult)) {
            return [
              {
                name: children.name,
                title: children.title
              }
            ].concat(childResult)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  padding-left: 0px;
  margin-bottom: 10px;
}
</style>
